import { Component, Input } from '@angular/core';
import { School } from 'bookraw/shared/models/school.model';
import { UserService } from 'bookraw/shared/services/user.service';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { Partner } from 'bookraw/shared/models/partner.model';
import { IMenuItem } from "bookraw/shared/services/navigation.service";

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html',
  styles: [`
    ul.sidenav > li.open > .lvl1 > a {
      background: rgba(0, 0, 1, 0.2) !important;
    }
    ul.sidenav > li span.custom-menu-icon {
      border-left: 3px solid transparent;
      height: 48px;
    }
    ul.sidenav > li.open span.custom-menu-icon {
      border-color: var(--bookr__menu-text);
    }
    ul.sidenav span.custom-menu-icon > .custom-icons {
      width: 18px;
      padding: 15px;
    }
    p.trial {
      color: #ffa831;
      padding: 0 10px;
    }
    p.trial > span {
      display: block;
      font-size: 12px;
    }
  `]
})
export class SidenavComponent {
  @Input('items') public menuItems: IMenuItem[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;

  partners: Partner[];
  schools: School[];
  selectedPartner: Partner;
  selectedSchool: School;
  loggedUser: string;

  constructor(
    public userService: UserService,
    private router: Router
  ) {
    this.schools = this.userService.user.schools;
    this.partners = this.userService.user.partners;
    this.selectedSchool = this.userService.school || null;
    this.selectedPartner = this.userService.partner || null;
    this.userService.loggedUserChange.subscribe(loggedUser => this.loggedUser = loggedUser);
  }

  public onPartnerChange(event: MatSelectChange) {
    this.userService.partner = this.userService.user.partners.find(partners => partners.id === event.value);
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  public onSelectionChange(event: MatSelectChange) {
    this.userService.school = this.userService.user.schools.find(schools => schools.id === event.value);
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  goToMyProfile() {
    this.router.navigate(['/my-profile']);
  }

}
